import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import T from "../translations/Translations";

import "../../styles/AddressBlock.scss";
import "../../styles/global/Global.scss";

/**
 * @name GuardianAddressBlock
 * @param {*} param0
 * @returns a Grey background block with user email and address
 * !!!!!! This is the GUARDIANS address block only. Top left of screen. !!!!!!
 */
const GuardianAddressBlock = ({ guardianInfo }) => {
    const [addressInfo, setAddressInfo] = useState(null);
    const [phone, setPhone] = useState("");

    const guardianTitle = T({ key: "OE_Student_Info_Guardian_Title" });
    const emailLabel = T({ key: "OE_Student_Info_Email" });
    const addressLabel = T({ key: "OE_Student_Info_Address" });
    const phoneLabel = T({ key: "OE_Student_Info_Phone" });
    const unavailable = T({ key: "OE_Unavailable" });

    useEffect(() => {
        if (guardianInfo) {
            const { address, addressDto, cellPhone, homePhone, workPhone, telephoneNumber } = guardianInfo;
            if (telephoneNumber) {
                setPhone(telephoneNumber);
            } else {
                setPhone(cellPhone || homePhone || workPhone);
            }
            if (address) {
                setAddressInfo(address);
            } else if (addressDto) {
                const { addressLine1, addressLine2, city, state, zip } = addressDto;
                if (addressLine1) {
                    setAddressInfo(`${addressLine1} ${addressLine2 || ""} ${city} ${state} ${zip}`);
                }
            }
        }
    }, [guardianInfo]);

    return (
        <div className="addressBlock-background">
            <div className="address-block-label">{guardianTitle}:</div>
            <hr />
            {guardianInfo && (
                <>
                    <div className="email-container">
                        <div className="email-label">{emailLabel}:</div>
                        <div className="email">{guardianInfo.email || unavailable}</div>
                    </div>
                    <div className="email-container">
                        <div className="email-label">{addressLabel}:</div>
                        <div className="email">{addressInfo || unavailable}</div>
                    </div>
                    <div className="email-container">
                        <div className="email-label">{phoneLabel}:</div>
                        <div className="email">{phone || unavailable}</div>
                    </div>
                </>
            )}
        </div>
    );
};

GuardianAddressBlock.propTypes = {
    guardianInfo: PropTypes.oneOfType([PropTypes.object])
};

GuardianAddressBlock.defaultProps = {
    guardianInfo: null
};

export default GuardianAddressBlock;
